<script>
import {
    layoutComputed
} from "@/state/helpers";
import Vertical from "./vertical";
import Horizontal from "./horizontal";

export default {
    components: {
        Vertical,
        Horizontal,
    },
    data() {
        return {
            headerOriginClass: ''
        };
    },
    computed: {
        ...layoutComputed,
    },
    methods: {},
    mounted() {
        if(env.API_ORIGIN === 'DEVELOP'){
          this.headerOriginClass = 'dev-main-bg'
        }
        if(env.API_ORIGIN === 'RELEASE'){
          this.headerOriginClass = 'pre-main-bg'
        }
        if(env.API_ORIGIN === 'PRODUCTION'){
          this.headerOriginClass = 'pro-main-bg'
        }
        if(env.API_ORIGIN === 'MASTER'){
          this.headerOriginClass = 'mst-main-bg'
        }
        // document.querySelector("html").setAttribute('dir', 'rtl');
    }
};
</script>

<template>
<div>
    <!-- <Vertical v-if="layoutType === 'vertical'" :layout="layoutType">
        <slot />
    </Vertical> -->

    <div v-bind:class="headerOriginClass">
        <slot />
    </div>

    <!-- <Horizontal v-if="layoutType === 'horizontal'" :layout="layoutType">
        <slot />
    </Horizontal> -->
</div>
</template>


<style>

  .dev-main-bg{
    background-image: url(../../assets/images/dev-origin-header-bg.png);
    background-size: 440px;
  }

  .pre-main-bg{
    background-image: url(../../assets/images/pre-origin-header-bg.png);
    background-size: 440px;
  }

  .pro-main-bg{
    background-image: url(../../assets/images/pro-origin-header-bg.png);
    background-size: 440px;
  }

  .mst-main-bg{
    background-color: #fff;
  }

</style>
